import { FC, ReactNode } from "react";
import styled from "styled-components";
import { default as AlertIc } from "img/icons/alert.svg";

interface NoticeProps {
  content: string | ReactNode;
}

const Notice: FC<NoticeProps> = ({ content }) => {
  return (
    <BaseNotice>
      <img alt="redirect-icon" src={AlertIc} />
      {content}
    </BaseNotice>
  );
};

const BaseNotice = styled.div`
  display: flex;
  padding: 24px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #f9ad2a;
  background: rgba(255, 185, 80, 0.1);

  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
`;

export default Notice;
